document.addEventListener('DOMContentLoaded', function () {
    const timeList = document.getElementById('dynamicTimeList');
    const dateInput = document.getElementById('date');
    const timeDropdown = document.querySelector('.order-options-column-time-options-dropdown');
    const timeButton = document.querySelector('.order-options-column-time-set-button');
    const message = document.getElementById('delivery-message');
    const deliTimeOption = document.querySelector('.deliveryTimeOption');
  
    // Function to format time in 12-hour format with am/pm
    function formatTime(hour, minutes) {
        const period = hour >= 12 ? 'pm' : 'am';
        const formattedHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        return `${formattedHour}:${formattedMinutes} ${period}`;
    }
  
    // Function to add minutes to a time
    function addMinutes(hour, minutes, increment) {
        const newMinutes = minutes + increment;
        if (newMinutes >= 60) {
            return [hour + 1, newMinutes - 60];
        }
        return [hour, newMinutes];
    }
  
    function generateTimeSlots() {
        // Clear existing time slots
        timeList.innerHTML = '';
  
        const selectedDate = new Date(dateInput.value);
        const storeLocationText = document.getElementById('store-location-text').textContent.trim().toLowerCase();
  
        const isFriday = selectedDate.getDay() === 4; // 4 represents Thursday
        const isSunToWed = selectedDate.getDay() >= 6 || selectedDate.getDay() <= 2; // Sun to Wed
        const isThurs = selectedDate.getDay() === 3;
        const isSat = selectedDate.getDay() === 5;
  
        let startHour = 12;
        let endHour = 19;
        let hour = startHour;
        let minutes = 0;
  
        if (storeLocationText.includes("pickup")) {
            timeDropdown.classList.add("show"); // Keep dropdown visible for pickup
            if (isFriday) {
                startHour = 11;
                endHour = 11;
                hour = startHour;
                minutes = 0;
                timeDropdown.classList.add("only-fri-dropdown");
            } else if (isSunToWed) {
                startHour = 12;
                endHour = 19;
                hour = startHour;
                minutes = 0;
            } else if (isThurs) {
                startHour = 12;
                endHour = 19;
                hour = startHour;
                minutes = 0;
            }
        } else if (storeLocationText.includes("delivery")) {
            timeDropdown.classList.remove("show"); // Hide dropdown for delivery
            if (isSunToWed || isThurs || isSat) {
                startHour = 14;
                endHour = 18;
                hour = startHour;
                minutes = 0;
            } else if (isFriday) {
                startHour = 10;
                endHour = 14;
                hour = startHour;
                minutes = 0;
            }
        }
  
        let firstTimeSlot = null;
  
        while (hour < endHour || (hour === endHour && minutes === 0)) {
            const formattedTime = formatTime(hour, minutes);
            const li = document.createElement('li');
            li.textContent = formattedTime;
  
            if (!firstTimeSlot) {
                firstTimeSlot = li;
            }
  
            timeList.appendChild(li);
  
            li.addEventListener('click', function () {
                const selectedLi = document.querySelector('.timeList li.selected');
                if (selectedLi) {
                    selectedLi.classList.remove('selected');
                }
  
                li.classList.add('selected');
                timeButton.textContent = `Selected Time: ${formattedTime}`;
            });
  
            [hour, minutes] = addMinutes(hour, minutes, 30);
        }
  
        if (firstTimeSlot) {
            firstTimeSlot.classList.add('selected');
            timeButton.textContent = `Selected Time: ${firstTimeSlot.textContent}`;
        }
  
        // Show and update the delivery window message
        if (storeLocationText.includes("delivery")) {
            deliTimeOption.style.display = "none";
            message.textContent = isFriday
                ? "Your order will arrive between 10:00 AM - 2:00 PM."
                : "Your order will arrive between 2:00 PM - 6:00 PM.";
        } else if (storeLocationText.includes("pickup")) {
            message.textContent = "Select your preferred pickup time.";
            deliTimeOption.style.display = "block";
        }
  
        message.style.display = "block"; // Show the message
    }
  
    // Generate time slots on date change
    dateInput.addEventListener('change', function () {
        timeButton.textContent = 'Select Time';
        const selectedLi = document.querySelector('.timeList li.selected');
        if (selectedLi) {
            selectedLi.classList.remove('selected');
        }
        timeDropdown.classList.remove("only-fri-dropdown");
        generateTimeSlots();
    });
  
    // Hide message initially
    message.style.display = "none";
  });
  
  
  $(document).ready(function() {
   //  $(".bottom-viewmenu-button").hide();
   //  $(".bottom-viewcart-button").click(function () {
   //      $(".mini_side_popup").toggle();
   //    $(".main_catering_content").toggle();
   //  });
  
   // $(".bottom-viewmenu-button").click(function () {
   //      $(".categories-products").show();
   //      $(".mini_side_popup").hide();
   //      $(".bottom-viewcart-button").show(); // Ensure viewcart button is visible
   //      $(".bottom-viewmenu-button").hide(); // Hide viewmenu button
   // }); 
  
      // Initial setup
    $('#cart-items-count').text('0');
    $('#cart-total-price').text('$0.00');
    $('#update-items-count').text('0');
    $('#update-total-price').text('$0.00');
    
    function getProductDetails(variantId, callback) {
    $.getJSON(`/variants/${variantId}.js`, function(product) {
      callback(product);
    }).fail(function(error) {
      console.error('Error fetching product details:', error);
    });
  }
  
    function updateCartSummary() {
        $.getJSON('/cart.js', function(cart) {
          // $('#cart-items-count').text(cart.item_count);
          // $('#cart-total-price').text(formatMoney(cart.total_price));
        }).fail(function(error) {
          console.error('Error fetching cart:', error);
        });
      }

    
    // Function to update the mini cart summary
    function updateMiniCartSummary() {
      $.getJSON('/cart.js', function(cart) {
        const subtotal = cart.items.reduce((acc, item) => acc + item.price * item.quantity, 0);
        const gst = subtotal * 0.10; // Assuming GST is 10%
        const totalWithGst = subtotal + gst;
  
        // $('#cart-total-price').text(formatMoney(cart.total_price));
        $('#cartMinePrice').text(formatMoney(cart.total_price));
        $('.cart-checkout-section span').text(`You have ${cart.item_count} items in your cart`);
  
        $('#cart-subtotal-price').text(formatMoney(subtotal));
        // $('#cart-gst-price').text(formatMoney(gst));
        // $('#cart-total-with-gst').text(formatMoney(totalWithGst));
  
        updateCartItems(cart.items);
      }).fail(function(error) {
        console.error('Error fetching cart:', error);
      });
    }
    
  
    // Function to update cart items
    function updateCartItems(items) {
      var $cartItemsContainer = $('.cart-items');
      $cartItemsContainer.empty(); // Clear current items
  
      items.forEach(function(item) {
        console.log(item);
        var variantOptionName = item.options_with_values[0]?.name || '';
        console.log(variantOptionName);
        var classMine = 'noHideEdit';
        if((item.title).indexOf('Package') > -1){
          var classMine = 'hideEdit';
        }
       var $cartItem = $('<div>', { 
    class: 'cart-item ' + classMine, 
    'data-variant-id': item.variant_id, 
    'product-id': item.product_id, 
    'mine': item.key 
  });
  
  $cartItem.html(`
    <img src="${item.image}" alt="${item.title}">
    <p class="item-quan">${item.quantity}x</p>
    <div class="title-package">
      <p class="item-title">${item.title}</p>
      
      <p class="item-properties">
        ${item.properties && item.properties.package_products ? item.properties.package_products + ',' : ''}
        ${item.properties && item.properties.option_items ? item.properties.option_items + ',' : ''}
        ${item.properties && item.properties.package_addon ? item.properties.package_addon : ''}
      </p>
          
    </div>
    <p class="item-price">${formatMoney(item.price)}</p>
    <div>
      <button class="update-cart" 
              data-variant-id="${item.variant_id}" 
              product-id="${item.product_id}" 
              data-handle="${item.handle}"  
              ${(variantOptionName === "Pound" || variantOptionName === "Piece") ? 'style="visibility: hidden;"' : ''}>
        Edit
      </button>
      <button class="remove-cart" data-variant-id="${item.variant_id}">x</button>
    </div>
  `);
  
          $cartItemsContainer.append($cartItem);
      });
  
      // Event handler for editing a cart item
     $('.update-cart').on('click', function() {
      var variantId = $(this).data('variant-id');
      var $itemElement = $(this).closest('.cart-item');
      var dataHandle = $(this).data('handle');
      var product = {
        image: $itemElement.find('img').attr('src') || '',
        title: $itemElement.find('p').eq(1).text(),
        price: parseFloat($itemElement.find('p').eq(2).text().replace('$', '')), // Ensure price is parsed as float
        variantId: variantId,
        quantity: parseInt($itemElement.find('p').eq(0).text()),
        notes: $itemElement.data('notes') || '',
        description: $itemElement.find('.product-description').text().trim(),  // Fetch product description
        productId: $itemElement.attr("product-id"),
        datavariants: $itemElement.attr('data-variants')
      };
      openQuickViewModal(product, 'update');
  
       // $.ajax({
       //    type: 'GET',
       //    url: '/products/'+dataHandle+'.json',
       //    dataType: 'json', 
       //    success: function (data) {
       //      var variants = data.product.variants;
       //      var dataVariants = '';
       //      $.each(variants, function( index, value ) {
       //        var title = value.title;
       //        var variantId = value.id;
       //        var price = value.price;
       //        dataVariants += title+'-'+variantId+'-$'+price+'-'+(price*100)+',';
       //      });
       //      setTimeout(function(){
       //        var product = {
       //          image: $itemElement.find('img').attr('src') || '',
       //          title: $itemElement.find('p').eq(1).text(),
       //          price: parseFloat($itemElement.find('p').eq(2).text().replace('$', '')), // Ensure price is parsed as float
       //          variantId: variantId,
       //          quantity: parseInt($itemElement.find('p').eq(0).text()),
       //          notes: $itemElement.data('notes') || '',
       //          description: $itemElement.find('.product-description').text().trim(),  // Fetch product description
       //          productId: $itemElement.attr("product-id"),
       //          datavariants: dataVariants
       //        };
       //        openQuickViewModal(product, 'update');
       //      }, 1000);
       //    }
       //  });
    });
  
   // Event handler for removing a cart item
      $('.remove-cart').on('click', function() {
        // var variantId = $(this).data('variant-id');
        // updateCartItem(variantId, 0);
        var key = $(this).parents('.cart-item').attr('mine');
        updateMine(key);
      });
    }
  
    // Function to update a cart item
  
    const updateMine = (key) => {
      $.ajax({
      type: 'GET',
      url: '/cart/change?id='+key+'&quantity=0',
      dataType: 'json',
      success: function(response) {
          console.log('Cart updated successfully:', response);
          updateCartSummary();
          updateMiniCartSummary();
          $modal.hide();
          
          if (response.item_count === 0) {
            window.location.href = '/collections/deli-menu';
          }
        },
        error: function(xhr, status, error) {
          console.error('Error updating cart:', error);
        }
      });
    }
    
  // Function to update a cart item
  function updateCartItem(variantId, quantity, notes) {
    var updateCartUrl = '/cart/change.js';
    var formData = {
      id: variantId,
      quantity: parseInt(quantity),
      properties: {
        'Notes': notes
      }
    };
  
    $.ajax({
      type: 'POST',
      url: updateCartUrl,
      data: formData,
      dataType: 'json',
      success: function(response) {
        console.log('Cart item updated:', response);
        updateCartSummary();
        updateMiniCartSummary();
        $modal.hide();
  
        if (response.item_count === 0) {
          window.location.href = '/collections/deli-menu';
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error('Error updating cart item:', jqXHR, textStatus, errorThrown);
      }
    });
  }
  
  
  function addToCart(variantId, quantity, notes, variantBarcode) {
    if (parseInt(quantity) <= 0) {
      document.getElementById('popup-message').innerText = "Please choose a quantity";
      document.getElementById('popup').style.display = 'block';
      
      document.querySelector('.close-popup').onclick = function() {
          closePopup();
      }
      
      window.onclick = function(event) {
          const modal = document.getElementById('popup');
          if (event.target === modal) {
              closePopup();
          }
      }
      
      function closePopup() {
          document.getElementById('popup').style.display = 'none';
      }
      
      window.onload = function() {
          const modal = document.getElementById('popup');
          modal.style.display = 'none';
      }
      return;
    }
  
    getProductDetails(variantId, function(product) {
      if (product.available) {  // Check if product is available
        var addToCartUrl = '/cart/add.js';
        var formData = {
          items: [{
            id: variantId,
            quantity: parseInt(quantity),
            properties: {
              'Notes': notes
            }
          }]
        };
  
        $.ajax({
          type: 'POST',
          url: addToCartUrl,
          data: JSON.stringify(formData),
          dataType: 'json',
          contentType: 'application/json',
          success: function(response) {
            console.log('Product added to cart:', response);
            updateCartSummary();
            updateMiniCartSummary();
            $modal.hide(); // Close the quick view modal after adding to cart
  
            // Show the cart and remove mini_side_popup class
            $('.cart-after-show').css('display','block');
            $('.mini_side_popup').removeClass('mini_side_popup');
            $('.cstm-sub-collections').addClass('active');
            if ($(".cstm-sub-collections").hasClass("active")) {
              $('.cart-after-show').css('background-color', '#fff');
             // $('div#mini_side_custom').addClass('cstm-miniside');
            } else {
              $('.cart-after-show').css('background-color', 'none');
               //$('div#mini_side_custom').removeClass('cstm-miniside');
             // $('.cstm-miniside').css('height', 'unset');
  
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.error('Error adding product to cart:', jqXHR, textStatus, errorThrown);
          }
        });
      } else {
      }
    });
  }
  
  
  // Function to open the quick view modal
  function openQuickViewModal(product, mode) {
    if(product.quantityOfPiece == undefined || product.quantityOfPiece == '' || product.quantityOfPiece == null ){
      var quantityOfPiece = 1;
    }else{
      var quantityOfPiece = product.quantityOfPiece;
    }
    if(product.image != undefined) {
      $('#quick-view-image').attr('src', product.image);
    }else{
      $('#quick-view-image').attr('src', '');
    }
    $('#quick-view-title').text(product.title);
    $('#quick-view-proDesc').text(product.description);
    $('.quick-view-functional').attr('product-id', product.productId);
    $('.quick-view-functional').attr('data-variant-title', product.datavariantTitle);
    $('.quick-view-functional select.product-variants').attr('data-variant-title', product.datavariantTitle);
    $('#quick-view-barcode').text(product.productBarcode);
    if(product.datavariantTitle == 'Pound' || product.datavariantTitle == 'Piece'){
      $('#product-notes').attr('placeholder', 'Please describe how many pieces or pounds you would like?');
    }else{
      $('#product-notes').attr('placeholder', 'Please add your order notes here.');
    }
    const dataVariants = product.datavariants;
    var dataVariantTitle = product.datavariantTitle;
    
    var $select = $('#quick-view-modal .product-variants');
    $select.empty();
  
    // $('p#variant_lb_msg').empty();
      
    if (dataVariants == undefined) {
      $('#quick-view-variant-id').val(product.variantId);
      $select.hide();
    } else {
      let variantsArray;
      try {
        variantsArray = JSON.parse(dataVariants);
        console.log(variantsArray); // Now it's a proper array
      } catch (e) {
        console.log("Error parsing variants");
      }
        
      var variantsMine = product.datavariants.split(',');
    
      let totalValidVariants = variantsMine.filter(item => item != '').length;
      let emptyItemCount = 0;
      // $select.append('<option value="" disabled selected>Select '+dataVariantTitle+'</option>');
    
      // Condition for hiding $select based on dataVariantTitle
      if (dataVariantTitle != "Pound" && dataVariantTitle != "Piece") {
        $select.hide();
        $('#quick-view-variant-id').val(dataVariants);
        $('p#variant_lb_msg').hide();
        $('.quick-view-price-pound span').hide();
      } else {
        // Populate the select options
        if(dataVariantTitle == "Pound"){
          $('p#variant_lb_msg').show();  
          $('.quick-view-price-pound span').text('/LB');
        } else {
          $('p#variant_lb_msg').hide();  
          $('.quick-view-price-pound span').text('/Piece');
        }
        
        variantsMine.forEach((item) => {
          if (totalValidVariants == '1' && item == '') {
            $select.hide();
          } else if (item == '') {
            // Do nothing
          } else {
            $select.show();
            if(item.split('-')[0] == '1'){
              $('#cart-items-count').text(1);
              $('#cart-total-price').text(item.split('-')[2]);
              $('#quick-view-variant-id').val(item.split('-')[1]);
              $select.append('<option selected value="' + item.split('-')[1] + '" price="' + item.split('-')[2] + '" data-price="' + item.split('-')[3] + '">' + item.split('-')[0] + ' ' + dataVariantTitle + '</option>');
            }
          }
        });
        
        // if (dataVariantTitle == "Pound"){
        //   $('p#variant_lb_msg').append('Final price will be adjusted based on weight');
        // }
    
        // Attach event listener to update the hidden input when a variant is selected
        $select.on('change', function() {
          var selectedVariant = $(this).val();
          if (selectedVariant) {
            $('#quick-view-variant-id').val(selectedVariant);
            console.log("Selected variant ID updated: " + selectedVariant); // Debugging
          }
        });
    
        // Initially set the variant ID to the first option if available
        if ($select.find('option').length > 0) {
          const firstVariantValue = $select.find('option:first').val();
          $('#quick-view-variant-id').val(firstVariantValue);
          console.log("Initial variant ID set: " + firstVariantValue); // Debugging
        }
      }
    }
  
  
    var priceString = product.price.toString(); // Convert price to string
    var price = parseFloat(priceString.replace('$', '').replace(',', '')); // Ensure correct parsing
  
    if (isNaN(price)) {
      price = 0; // Default to 0 if price is NaN
    }
  
    // Format the price with the currency symbol
    $('#quick-view-price').text(formatMoney(price * 100));
  
    $('#quick-view-quantity').val(product.quantity || 0); // Start from 0 or existing quantity
    $('#product-notes').val(product.notes || ''); // Clear or set notes input
  
    if (mode === 'update') {
      $('#quick-view-add-to-cart').hide();
      // $('select.product-variants').hide();
      $('#quick-view-update').show();
      $('#update-items-count').text(product.quantity);
      $('#update-total-price').text(formatMoney(product.quantity * price * 100));
      $('#update-items-count, #update-total-price').show(); // Ensure they are shown
      $('#cart-items-count, #cart-total-price').hide(); // Hide cart totals
    } else {
      $('#quick-view-update').hide();
      // $('select.product-variants').show();
      $('#quick-view-add-to-cart').show();
      $('#update-items-count, #update-total-price').hide(); // Hide update counts
      // $('#cart-items-count').text('0').show(); // Show cart items count
      // $('#cart-total-price').text('$0.00').show(); // Show cart total price
    }
    if(quantityOfPiece > 1){
      var newPrice = (product.price).trim();
      newPrice = parseFloat(newPrice) * quantityOfPiece;
      newPrice = parseFloat(newPrice).toFixed(2);
      $('#cart-items-count').text('1').show(); // Show cart items count
      $('#cart-total-price').text('$'+newPrice).show(); // Show cart total price
    }
    $modal.show();
  }
  
  
  
  // Function to format money
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  
    // Event handler for updating quantity in quick view modal
    $('#quick-view-update').on('click', function() {
      var variantId = $('#quick-view-variant-id').val();
      var quantity = $('#quick-view-quantity').val();
      var notes = $('#product-notes').val();
      
      if (!variantId) {
        alert('There was an error with the variant ID.');
        return;
      }
     updateCartItem(variantId, quantity, notes);
    });
  
    $('#product-notes').on('input', function () {
      var checkVariant = $(this).parents('.quick-view-functional').attr('data-variant-title');
        if(checkVariant == 'Pound' || checkVariant == 'Piece'){
          let value = $(this).val();
          if(value.length <= 3 && value.length > 0){
            $('.errorsList').remove();
            $('#quick-view-add-to-cart').addClass('nonActive');
            $('#notes-popup').append('<div class="errorsList">Enter more than 3 characters to add a product in cart.</div>');
            $('#product-notes').addClass('error');
          }else if(value.length <= 0){
            $('#quick-view-add-to-cart').removeClass('nonActive');
            $('.errorsList').remove();
            $('#product-notes').removeClass('error');
          }else{
            $('#quick-view-add-to-cart').removeClass('nonActive');
            $('.errorsList').remove();
            $('#product-notes').removeClass('error');
          }
          $(this).val(value);
        }
    });
  
    // Event handler for adding to cart from quick view modal
    $('#quick-view-add-to-cart').on('click', function() {
        var variantId = $('#quick-view-variant-id').val();
        var variantBarcode = $('#quick-view-barcode').text();
        var quantity = $('#quick-view-quantity').val();
        var notes = $('#product-notes').val();
        var checkVaraint = $('.quick-view-functional').attr('data-variant-title');
        if(checkVaraint == 'Pound' || checkVaraint == 'Piece'){
          if(notes != ''){
            if (!variantId) {
              document.getElementById('popup-message').innerText = "Please choose a quantity";
              document.getElementById('popup').style.display = 'block';
              
              document.querySelector('.close-popup').onclick = function() {
                  closePopup();
              }
              
              window.onclick = function(event) {
                  const modal = document.getElementById('popup');
                  if (event.target === modal) {
                      closePopup();
                  }
              }
              
              function closePopup() {
                  document.getElementById('popup').style.display = 'none';
              }
              
              window.onload = function() {
                  const modal = document.getElementById('popup');
                  modal.style.display = 'none';
              }
              return;
            }
            var quantity = 1;
             addToCart(variantId, quantity, notes, variantBarcode);
          }else{
            $('#product-notes').addClass('error');
            $('.errorsList').remove();
            $('#notes-popup').append('<div class="errorsList">Please Enter pieces or LBS that you want to add in the order.</div>');
            
          }
        }else{
          if (!variantId) {
              document.getElementById('popup-message').innerText = "Please choose a quantity";
              document.getElementById('popup').style.display = 'block';
              
              document.querySelector('.close-popup').onclick = function() {
                  closePopup();
              }
              
              window.onclick = function(event) {
                  const modal = document.getElementById('popup');
                  if (event.target === modal) {
                      closePopup();
                  }
              }
              
              function closePopup() {
                  document.getElementById('popup').style.display = 'none';
              }
              
              window.onload = function() {
                  const modal = document.getElementById('popup');
                  modal.style.display = 'none';
              }
              return;
            }
             addToCart(variantId, quantity, notes, variantBarcode);
        }
        
      });
  
    // Event handler for increasing the quantity in quick view modal
     $('#increase-quantity').on('click', function() {
        var $quantityInput = $('#quick-view-quantity');
        var currentValue = parseInt($quantityInput.val());
        $quantityInput.val(currentValue + 1);
    
        // Update total price
        var price = parseFloat($('#quick-view-price').text().replace('$', ''));
        $('#update-items-count').text($quantityInput.val());
        $('#update-total-price').text('$' + ($quantityInput.val() * price).toFixed(2));
    
        // Update cart items count and total price
        $('#cart-items-count').text($quantityInput.val());
        $('#cart-total-price').text('$' + ($quantityInput.val() * price).toFixed(2));
      });
  
    // Event handler for decreasing the quantity in quick view modal
    $('#decrease-quantity').on('click', function() {
      var $quantityInput = $('#quick-view-quantity');
      var currentValue = parseInt($quantityInput.val());
      if (currentValue > 0) {
        $quantityInput.val(currentValue - 1);
      }
  
      // Update total price
      var price = parseFloat($('#quick-view-price').text().replace('$', ''));
      $('#update-items-count').text($quantityInput.val());
      $('#update-total-price').text('$' + ($quantityInput.val() * price).toFixed(2));
  
      // Update cart items count and total price
      $('#cart-items-count').text($quantityInput.val());
      $('#cart-total-price').text('$' + ($quantityInput.val() * price).toFixed(2));
    });
  
    // Event handler for adding notes
    $('#quick-view-add-notes').on('click', function() {
      var notes = $('#product-notes').val();
      //alert('Notes added: ' + notes);
    });
  
    // Event handler for adding notes in quick view modal
    $('#add-notes').on('click', function() {
      $notesPopup.removeClass('hide');
    });
  
    // Event handler for saving notes in quick view modal
    $('#save-notes').on('click', function() {
      var notes = $('#product-notes').val();
      $('#notes-text').text(notes);
      $notesPopup.addClass('hide');
    });
  
    // Event handler for canceling notes in quick view modal
    $('#cancel-notes').on('click', function() {
      $notesPopup.addClass('hide');
    });
  
    // Variables for modal and notes popup elements
    var $modal = $('#quick-view-modal');
    var $notesPopup = $('#notes-popup');
  
    // Event handler for closing the quick view modal
    $('.close').on('click', function() {
      $modal.hide();
    });
  
    // Event handler for clicking outside the quick view modal to close it
    $(window).on('click', function(event) {
      if (event.target.id === 'quick-view-modal') {
        $modal.hide();
      }
    });
  
  $(document).on('click', '.product-item', function(event) {
    event.preventDefault();
    var $target = $(this);
    var quantityOfPiece = $target.attr('quantity-data');
    if(quantityOfPiece == undefined || quantityOfPiece == ''){
      quantityOfPiece = 1;
    }else{
      quantityOfPiece = parseInt(quantityOfPiece);
    }
    $('#quick-view-add-to-cart').removeClass('nonActive');
    $('.errorsList').remove();
    $('#product-notes').removeClass('error');
    if ($target.attr('data-variant-title') == 'Pound' || $target.attr('data-variant-title') == 'Piece') {
      $('.quantity-wrapper').hide();  
      const $variantSelect = $(this).find('.product-variants');
      const $firstOption = $variantSelect.find('option[value]:not([disabled])').first();
      if ($firstOption.length > 0) {
          $variantSelect.val($firstOption.val()).trigger('change');
          console.log('$variantSelect.val($firstOption.val()).trigger' + $variantSelect.val($firstOption.val()).trigger('change'));
      }
    }else{
      $('.quantity-wrapper').show();
      var $quantityInput = $('#quick-view-quantity');
        var currentValue = parseInt($quantityInput.val());
    
        // Update total price
        var price = parseFloat($('#quick-view-price').text().replace('$', ''));
    
        // Update cart items count and total price
        // $('#cart-items-count').text($quantityInput.val());
        // $('#cart-total-price').text('$' + ($quantityInput.val() * price).toFixed(2));
        $('#cart-items-count').text('0');
        $('#cart-total-price').text('$0.00');
    }
  
    var first_variant = $target.attr('data-variants');
    if (first_variant) {
        var parts = first_variant.replace(/,$/, '').split('-');
        if (parts.length > 0 && parts[0] == 'Default Title') {
            var defaultvariant = parts[1];
        } else {
            var defaultvariant = $target.attr('data-variants');
        }
    }
    var product = {
      description: $target.find('.product-description').text(),
      image: $target.find('img').attr('src'),
      secondImage: $target.find('img.second-img').attr('src'),
      title: $target.find('.product-title').text(),
      price: $target.find('.product-price').text().replace('$', '').replace(',', ''), // Ensure price is correctly formatted
      variantId: $target.data('variant-id'),
      // sellInPounds: $target.attr("data-sell-by-pounds"),
      productId: $target.attr("product-id"),
      datavariants: defaultvariant,
      datavariantTitle: $target.attr('data-variant-title'),
      productBarcode: $target.data('barcode'),
      quantityOfPiece: quantityOfPiece
    };
    openQuickViewModal(product, 'add');
  });
  
  $(document).on('click', '.product-grid-container .grid__item', function(event) {
    event.preventDefault();
    var $target = $(this);
     var quantityOfPiece = $target.attr('quantity-data');
    if(quantityOfPiece == undefined || quantityOfPiece == ''){
      quantityOfPiece = 1;
    }else{
      quantityOfPiece = parseInt(quantityOfPiece);
    }
    if($target.attr('data-variant-title') == 'Pound' || $target.attr('data-variant-title') == 'Piece'){
      $('.quantity-wrapper').hide();  
    }else{
      $('.quantity-wrapper').show();
    }
  
    var first_variant = $target.attr('data-variant-title');
    if (first_variant) {
        var parts = first_variant.replace(/,$/, '').split('-');
        if (parts.length > 0 && parts[0] == 'Default Title') {
            var defaultvariant = parts[1];
        } else {
            var defaultvariant = $target.attr('data-variant-title');
        }
    }else{
      var defaultvariant = $target.attr('data-variant-title');
    }
    var product = {
      image: $target.find('.card__media img').attr('src'),
      secondImage: $target.find('.card__media img.second-img').attr('src'),
      title: $target.find('.cstm-card-heading').text(),
      price: $target.find('.price-item--sale').text().replace('$', '').replace(',', '').replace('From', '').trim(), // Ensure price is correctly formatted
      variantId: $target.data('variant-id'),
      productId: $target.attr("product-id"),
      datavariants: defaultvariant,
      datavariantTitle: $target.attr('data-variant-title'),
      productBarcode: $target.data('barcode'),
      quantityOfPiece: quantityOfPiece
    };
    openQuickViewModal(product, 'add');
  });
    
    // Initial update of cart summary
    updateCartSummary();
    updateMiniCartSummary();
  
  });
  
  $(document).ready(function() {
    // Prevent form submission on Enter
    $('#search-form').on('submit', function(event) {
      event.preventDefault(); // Prevents the default form submission
    });
  
    // Search functionality
    $('#product-search').on('keyup', function() {
      var query = $(this).val().toLowerCase();
      var $products = $('.product-item.subcollections');
  
      // Search through each product
      $products.each(function() {
        var $product = $(this);
        var title = $product.find('.product-title').text().toLowerCase();
        var tags = $product.data('tags') ? $product.data('tags').toString().toLowerCase() : '';
  
        // Show or hide the product based on the search query
        if (title.includes(query) || tags.includes(query)) {
          $product.show();
        } else {
          $product.hide();
        }
      });
    });
  });
  
  
  
  
  function updateCart() {
    var $productVariant = $('.product-variants');
    var weight = $productVariant.find('option:selected').attr('price');
    var quantityMine = $productVariant.parent().find('.quantity-wrapper input[type="text"]').val();
    var dataVariantTitle = $productVariant.attr('data-variant-title');
    
    // Ensure quantity is a number (default to 1 if not provided)
    quantityMine = parseInt(quantityMine) || 1;
  
    if (dataVariantTitle == 'Pound' || dataVariantTitle == 'Piece') {
      var dataPrice = $productVariant.find('option:selected').data('price');
      dataPrice = parseFloat(dataPrice) * quantityMine;
      dataPrice = dataPrice / 100;
      $('#cart-total-price').html('$' + dataPrice.toFixed(2)); // Format the price
      $('#quick-view-quantity').val(quantityMine);
      $('#cart-items-count').text(quantityMine);
    } else {
      if (quantityMine >= 2) {
        var dataPrice = $productVariant.find('option:selected').data('price');
        dataPrice = parseFloat(dataPrice) * quantityMine;
        dataPrice = dataPrice / 100;
        $('#cart-total-price').html('$' + dataPrice.toFixed(2)); // Format the price
      } else if (quantityMine == 1) {
        $('#cart-total-price').html(weight);
      } else {
        // Handle case for 0 or invalid quantity if needed
      }
    }
  }
  
  // Call the function to set the default values on page load
  $(document).ready(function() {
    updateCart(); // Set default values on page load
  
    // Handle change event for when a variant is selected
    $('.product-variants').on('change', function() {
      updateCart(); // Update cart when selection changes
    });
  });
  
  // function updateTotalPrice(weight) {
  //     var pricePerPound = parseFloat($('#quick-view-price').text().replace('$', ''));
  
  //     var totalPrice = (pricePerPound * weight).toFixed(2);
  //     console.log(pricePerPound);
  //     $('#update-total-price').text('$' + totalPrice);
      
  //     $('#update-items-count').text(weight);
  //     $('#cart-items-count').text(weight);
  //     $('#cart-total-price').text('$' + totalPrice);
  // }
  
  
  
  
  
  $(document).ready(function() {
      // $('.checkout-button a').on('click', function(e) {
      //     e.preventDefault();
  
      //     $('.saveDateTime').click();
      //     let cartValue = $('#cartMinePrice').text();
      //     let numericValue = parseInt(cartValue.replace('$', ''));
  
      //     if(numericValue > 0){
      //       let dateSelected = $('#date').val();
      //       let timeSelected = $('ul.timeList li.selected').length;
            
      //       $('div#mini_side_custom').addClass('mini_side_popup');
        
    
      //       if (!dateSelected) {
      //           $('.deliveryDateTime').click();
      //           // alert('Please choose a time for pickup.');
      //         $('div#mini_side_custom').addClass('remove_mini_side_popup');
      //       } else if (timeSelected === 0) {
      //         $('.deliveryDateTime').click();
      //           // alert('Please choose a date for pickup.');
      //       } else {
      //           window.location.href = $(this).attr('href');
      //       }
      //   }else{
      //       alert('Please add an item to cart.');
      //   }
      // });
  
      $('ul.timeList li').on('click', function() {
          $('ul.timeList li').removeClass('selected');
          $(this).addClass('selected');
      });
  
  
  
  
  
    $('.checkout-button a').on('click', function(e) {
      e.preventDefault();
      let cartValue = $('#cartMinePrice').text();
      let numericValue = parseInt(cartValue.replace('$', ''));
  
  
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
  
      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? String(hours).padStart(2, '0') : '12';
  
      const formattedTime = `${hours}:${minutes} ${ampm}`;
  
      // Save date and time attributes
      var date = $('#date').val();
      var time = $('.order-options-column-time-set-button').html();
  
      if (time.startsWith("Selected Time: ")) {
          time = time.replace("Selected Time: ", "").trim();
      }
  
      // Check if date and time are 
      if (numericValue > 0) {
          let dateSelected = $('#date').val();
          let timeSelected = $('ul.timeList li.selected').length;
  
          $('div#mini_side_custom').addClass('mini_side_popup');
  
          if (!dateSelected) {
              $('.deliveryDateTime').click();
              $('div#mini_side_custom').addClass('remove_mini_side_popup');
          } else if (date && time) {
              const selectedDateTimeString = `${date} ${time}`;
  
              // Split the string into date and time parts
              const [datePart, timePartWithPeriod] = selectedDateTimeString.split(' ');
              const [hours, minutes] = timePartWithPeriod.split(':');
              const period = selectedDateTimeString.includes('pm') ? 'pm' : 'am';
              
              // Parse the date part
              const [year, month, day] = datePart.split('-').map(Number);
              
              // Adjust hours for 12-hour clock
              let hour = parseInt(hours, 10);
              if (period === 'pm' && hour < 12) hour += 12; // Convert PM hours
              if (period === 'am' && hour === 12) hour = 0; // Adjust for midnight
              
              // Format as ISO string
              const isoDateTime = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hour).padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
            
              const selectedDateTime = new Date(isoDateTime);
      
              if (isNaN(selectedDateTime.getTime())) {
                  console.error("Selected DateTime: Invalid Date");
              } else {
                  const timeDifference = selectedDateTime - now;
                  const hoursDifference = timeDifference / (1000 * 60 * 60);
      
                  // Fetch cart data
                  fetch('/cart.js')
                      .then(response => response.json())
                      .then(cart => {

                        const totalPriceCents = cart.total_price;
                        const totalPriceDollars = (totalPriceCents / 100).toFixed(2);
      
                          let unavailableProducts = [];
                          let sunToWedProducts = [];
                          let webToFriProducts = [];
                          let thursFriProducts = [];
                          let allWeekProducts = [];
                          let checkfriday = [];
                          let allWeekfourProducts = [];
                          let packageProducts = [];
                          let feHour = [];
                          console.log(totalPriceDollars + 'totalPriceDollars');
                          cart.items.forEach(item => {
                              fetch(`/products/${item.handle}.js`)
                                  .then(response => response.json())
                                  .then(product => {
                                      console.log("Tags for", product.title, ":", product.tags);
      
                                      const selectedDay = selectedDateTime.getDay();
                                      // Validate availability of products based on tags
                                      // Check if the product contains any of the relevant tags
                                      if (product.tags.includes("Package")) {
                                          // const isWithinPackageDates =
                                          //     selectedYear === 2024 &&
                                          //     ((selectedMonth === 11 && selectedDate >= 22) || // December, starting 22nd
                                          //         (selectedMonth === 0 && selectedDate <= 2)); // January, until 2nd
                                      
                                          // if (!isWithinPackageDates) {
                                          //     packageProducts.push(product.title);
                                          //     $('#date').val('');
                                          if (hoursDifference <= 24) {
                                              unavailableProducts.push(product.title);
                                              $('#date').val('');
                                          }
                                      }
                                      
                                      if (product.tags.includes("Thurs Night")) {
                                          // const isThursNightValid = selectedYear === 2024 && selectedMonth === 11 && selectedDate === 26;
                                      
                                          // if (!isThursNightValid) {
                                          //     $('#date').val(''); // Clear the date input
                                          //     showPopup(`The "${product.title}" is only available on Thursday December 26, 2024.`);
                                          // }
                                          if (selectedDay != 4) {
                                              $('#date').val(''); // Clear the date input
                                              showPopup(`The "${product.title}" is only available on Thursdays`);
                                          } else if (hoursDifference <= 24){
                                              unavailableProducts.push(product.title);
                                              $('#date').val('');
                                          }                                      
                                      }
                                      if (product.tags.includes("24 hour")) {
                                          if (hoursDifference <= 24) {
                                              unavailableProducts.push(product.title);
                                              $('#date').val('');
                                          }
                                      } else if (product.tags.includes("48 hour")) {
                                          if (hoursDifference <= 48) {
                                              feHour.push(product.title);
                                              $('#date').val('');
                                          }
                                      } else if (product.tags.includes("Sun-Wed")) {
                                          if (selectedDay > 3) {
                                              sunToWedProducts.push(product.title);
                                              $('#date').val('');
                                          }
                                      } else if (product.tags.includes("Wed-Fri")) {
                                          if (selectedDay < 3 || selectedDay > 5) {
                                              webToFriProducts.push(product.title);
                                              $('#date').val('');
                                          }
                                      } else if (product.tags.includes("Thurs & Fri")) {
                                          if (selectedDay != 4 && selectedDay != 5) {
                                              thursFriProducts.push(product.title);
                                              $('#date').val('');
                                          }
                                      } else if (product.tags.includes("All Week")) {
                                          if (selectedDay == 0) {
                                              allWeekProducts.push(product.title);
                                              $('#date').val('');
                                          } else if (hoursDifference < 4 && storeLocationText.includes("pickup")) {
                                              allWeekfourProducts.push(product.title);
                                              $('#date').val('');
                                          }
                                      } else if (hoursDifference < 4 && storeLocationText.includes("pickup")) {
                                          allWeekfourProducts.push(product.title);
                                          $('#date').val('');
                                      }
                                    
                                     if (selectedDay == 5 && totalPriceDollars <= 50) {
                                        checkfriday.push('$50 Minimum for Pickup Orders on Friday');
                                        $('#date').val('');
                                     }
      
                                      const formattedDateTime = `${selectedDateTime.toLocaleDateString()} ${selectedDateTime.toLocaleTimeString()}`;
                                      $('.deliveryDateTime').text(formattedDateTime);
                                  })
                                  .catch(error => console.error("Error fetching product details:", error));
                          });
      
                          Promise.all(cart.items.map(item => fetch(`/products/${item.handle}.js`).then(response => response.json())))
                              .then(() => {
                                  if (unavailableProducts.length > 0) {
                                      let productList = unavailableProducts.join(", ");
                                      showPopup(`The following products are not available within 24 hours: ${productList}. Please select a date and time that is at least 24 hours from now.`);
                                  } else if (checkfriday.length > 0){
                                      showPopup(`$50 Minimum for Pickup Orders on Friday`);
                                  } else if (packageProducts.length > 0){
                                      let productList = packageProducts.join(", ");
                                      showPopup(`CHANUKAH Packages are available from Dec 22, 2024 to Jan 2, 2025.`);
                                  } else if (feHour.length > 0) {
                                      let productList = feHour.join(", ");
                                      showPopup(`The following products are not available within 48 hours: ${productList}. Please select a date and time that is at least 48 hours from now.`);
                                  } else if (sunToWedProducts.length > 0) {
                                      let sunToWedList = sunToWedProducts.join(", ");
                                      showPopup(`The following products are only available between Sunday and Wednesday: ${sunToWedList}. Please select a valid date and time between Sunday and Wednesday.`);
                                  } else if (webToFriProducts.length > 0) {
                                      let webToFriList = webToFriProducts.join(", ");
                                      showPopup(`The following products are only available between Wednesday and Friday: ${webToFriList}. Please select a valid date and time between Wednesday and Friday.`);
                                  } else if (thursFriProducts.length > 0) {
                                      let thursFriList = thursFriProducts.join(", ");
                                      showPopup(`The following products are only available on Thursday and Friday: ${thursFriList}. Please select a valid date and time on Thursday and Friday.`);
                                  } else if (allWeekProducts.length > 0) {
                                      let allWeekList = allWeekProducts.join(", ");
                                      showPopup(`The following products are only available between Sunday and Friday: ${allWeekList}. Please select a valid date and time between Sunday and Friday.`);
                                  } else if (allWeekfourProducts.length > 0) {
                                      let allWeekfourList = allWeekfourProducts.join(", ");
                                      showPopup(`The following products are only available after 4 hours: ${allWeekfourList}. Please select a time.`);
                                  } else {
                                      // If no issues, proceed with saving the selected date and time
                                      var attributes = {
                                          'attributes[date]': date,
                                          'attributes[time]': time
                                      };
      
                                      $.ajax({
                                          type: 'POST',
                                          url: '/cart/update.js',
                                          data: attributes,
                                          dataType: 'json',
                                          success: function() {
                                              console.log('Date and time saved to cart attributes');
                                              $('.deliveryTimePopup').addClass('hide');
                                          },
                                          error: function() {
                                              console.log('Error saving date and time to cart attributes');
                                          }
                                      });
  
                                      // window.location.href = $(this).attr('href');
                                      window.location.href = '/cart';
      
                                      // After date and time validation, continue with checkout redirection
                                      
      
                                      // if (numericValue > 0) {
                                      //     let dateSelected = $('#date').val();
                                      //     let timeSelected = $('ul.timeList li.selected').length;
      
                                      //     $('div#mini_side_custom').addClass('mini_side_popup');
      
                                      //     if (!dateSelected) {
                                      //         $('.deliveryDateTime').click();
                                      //         $('div#mini_side_custom').addClass('remove_mini_side_popup');
                                      //     } else if (timeSelected === 0) {
                                      //         $('.deliveryDateTime').click();
                                      //     } else {
                                      //         window.location.href = $(this).attr('href');
                                      //     }
                                      // } else {
                                      //     alert('Please add an item to cart.');
                                      // }
                                  }
                              })
                              .catch(error => console.error("Error processing products:", error));
                      })
                      .catch(error => console.error("Error fetching cart:", error));
              }
        } else if (timeSelected === 0) {
              $('.deliveryDateTime').click();
        } else {
            alert('Please add an item to cart.');
        }
      }
  
      function showPopup(message) {
              document.getElementById('popup-message').innerText = message; // Set the message
              document.getElementById('popup').style.display = 'block'; // Show the popup
          }
          
          // Close the popup when the user clicks on <span> (x)
          document.querySelector('.close-popup').onclick = function() {
              closePopup();
          }
          
          // Close the popup when the user clicks anywhere outside of the modal
          window.onclick = function(event) {
              const modal = document.getElementById('popup');
              if (event.target === modal) {
                  closePopup();
              }
          }
          
          // Function to hide the popup
          function closePopup() {
              document.getElementById('popup').style.display = 'none'; // Hide the popup
          }
          
          // Add event listener to open the popup again if it is closed
          window.onload = function() {
              const modal = document.getElementById('popup');
              modal.style.display = 'none'; // Ensure the modal is hidden on page load
          }
  });
  
  
    
  });
  
  
  // jQuery(document).ready(function() {
  //     const deliveryTimeOption = document.querySelector('.deliveryTimeOption'); // The element to hide
  //     const storeLocationText = document.getElementById('store-location-text').textContent.trim().toLowerCase();
  //     if (storeLocationText === "delivery"){
  //         deliveryTimeOption.style.visibility = 'hidden';
  //     } else {
  //         deliveryTimeOption.style.visibility = 'visible';
  //     }
  // });